import * as keyboard from 'util/Keyboard';

export const TAB: keyboard.KeyboardShortcut = {
  matches: (e) => keyboard.isTabKey(e) && !e.shiftKey,
  description: {
    description: 'Navigate to the next cell (right)',
    shortcut: {normalizedShortcutText: 'Tab'},
  },
};

export const SHIFT_TAB: keyboard.KeyboardShortcut = {
  matches: (e) => keyboard.isTabKey(e) && e.shiftKey,
  description: {
    description: 'Navigate to the previous cell (left)',
    shortcut: {normalizedShortcutText: 'Shift + Tab'},
  },
};

export const ENTER: keyboard.KeyboardShortcut = {
  matches: (e) => keyboard.isEnterKey(e) && !e.shiftKey,
  description: {
    description: 'Edit cell / (while editing) Move down',
    shortcut: {normalizedShortcutText: 'Enter'},
  },
};

export const SHIFT_ENTER_MOVE_UP: keyboard.KeyboardShortcut = {
  matches: (e) => keyboard.isEnterKey(e) && e.shiftKey,
  description: {
    description: 'Finish edit and move up (while editing)',
    shortcut: {normalizedShortcutText: 'Shift + Enter'},
  },
};

export const F2: keyboard.KeyboardShortcut = {
  matches: (e) => e.key === 'F2',
  description: {
    description: 'Edit cell',
    shortcut: {normalizedShortcutText: 'F2'},
  },
};

export const ESCAPE: keyboard.KeyboardShortcut = {
  matches: keyboard.isEscapeKey,
  description: {
    description: 'Cancel editing / Clear selection',
    shortcut: {normalizedShortcutText: 'Esc'},
  },
};

export const DELETE: keyboard.KeyboardShortcut = {
  matches: keyboard.isADeleteKey,
  description: {
    description: 'Clear cell contents',
    shortcut: {normalizedShortcutText: 'Delete'},
  },
};

export const CTRL_A: keyboard.KeyboardShortcut = {
  matches: keyboard.isCtrlA,
  description: {
    description: 'Select all cells',
    shortcut: {normalizedShortcutText: 'Ctrl + A'},
  },
};

export const ARROW_KEYS: keyboard.KeyboardShortcut = {
  matches: (e) => keyboard.isAnArrowKey(e) && !e.shiftKey && !keyboard.isOSCtrlKey(e),
  description: {
    description: 'Move selection in arrow direction',
    shortcut: {normalizedShortcutText: 'Arrow Keys'},
  },
};

export const ARROW_KEYS_EXTEND: keyboard.KeyboardShortcut = {
  matches: (e) => keyboard.isAnArrowKey(e) && e.shiftKey && !keyboard.isOSCtrlKey(e),
  description: {
    description: 'Extend selection in arrow direction',
    shortcut: {normalizedShortcutText: 'Shift + Arrow'},
  },
};

export const ARROW_KEYS_JUMP: keyboard.KeyboardShortcut = {
  matches: (e) => keyboard.isAnArrowKey(e) && !e.shiftKey && keyboard.isOSCtrlKey(e),
  description: {
    description: 'Move to edge of data region',
    shortcut: {normalizedShortcutText: 'Ctrl + Arrow'},
  },
};

export const ARROW_KEYS_EXTEND_JUMP: keyboard.KeyboardShortcut = {
  matches: (e) => keyboard.isAnArrowKey(e) && e.shiftKey && keyboard.isOSCtrlKey(e),
  description: {
    description: 'Extend selection to edge of data region',
    shortcut: {normalizedShortcutText: 'Ctrl + Shift + Arrow'},
  },
};

/** EXPERIMENTAL SHORTCUTS (under config flag) */

export const SHIFT_SPACE: keyboard.KeyboardShortcut = {
  matches: keyboard.isShiftSpace,
  description: {
    description: 'Select current row',
    shortcut: {normalizedShortcutText: 'Shift + Space'},
  },
};

export const CTRL_SPACE: keyboard.KeyboardShortcut = {
  matches: keyboard.isCtrlSpace,
  description: {
    description: 'Select current column',
    shortcut: {normalizedShortcutText: 'Ctrl + Space', skipOsTranslation: true},
  },
};

// Navigation to edges
export const HOME: keyboard.KeyboardShortcut = {
  matches: keyboard.isHomeKey,
  description: {
    description: 'Jump to start of row',
    shortcut: {normalizedShortcutText: 'Home'},
  },
};

export const END: keyboard.KeyboardShortcut = {
  matches: keyboard.isEndKey,
  description: {
    description: 'Jump to end of row',
    shortcut: {normalizedShortcutText: 'End'},
  },
};

export const PAGE_UP: keyboard.KeyboardShortcut = {
  matches: keyboard.isPageUpKey,
  description: {
    description: 'Jump to top of column',
    shortcut: {normalizedShortcutText: 'PageUp'},
  },
};

export const PAGE_DOWN: keyboard.KeyboardShortcut = {
  matches: keyboard.isPageDownKey,
  description: {
    description: 'Jump to bottom of column',
    shortcut: {normalizedShortcutText: 'PageDown'},
  },
};

export const SHIFT_ENTER_INSERT_ROW: keyboard.KeyboardShortcut = {
  matches: keyboard.isShiftEnter,
  description: {
    description: 'Insert new row below',
    shortcut: {normalizedShortcutText: 'Shift + Enter'},
  },
};

export const EXPERIMENTAL_TABLE_SHORTCUTS = [
  SHIFT_SPACE,
  CTRL_SPACE,
  HOME,
  END,
  PAGE_UP,
  PAGE_DOWN,
  SHIFT_ENTER_INSERT_ROW,
];

export const TABLE_SHORTCUTS = [
  TAB,
  SHIFT_TAB,
  ENTER,
  SHIFT_ENTER_MOVE_UP,
  F2,
  ESCAPE,
  ARROW_KEYS,
  ARROW_KEYS_EXTEND,
  ARROW_KEYS_JUMP,
  ARROW_KEYS_EXTEND_JUMP,
  CTRL_A,
];
